import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";

const gapMaps = [
  {
    id: 1,
    title: "Today's Facts",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-04-the-gap-map-todays-facts.mp4",
  },
  {
    id: 2,
    title: "Today's Feelings",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-05-the-gap-map-todays-feelings.mp4",
  },
  {
    id: 3,
    title: "URGENCY",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-06-the-gap-map-urgency.mp4",
  },
  {
    id: 4,
    title: "WHAT GOT ME HERE",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-07-the-gap-map-alignment-today.mp4",
  },
  {
    id: 5,
    title: "Future Facts",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-09-the-gap-map-future-facts.mp4",
  },
  {
    id: 6,
    title: "Future Feelings",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-08-the-gap-map-future-feelings.mp4",
  },
  {
    id: 7,
    title: "Future Impact",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-10-the-gap-map-future-impact.mp4",
  },
  {
    id: 8,
    title: "WHAT DO I HAVE TO BECOME",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-11-the-gap-map-future-you.mp4"
  },
];

const GapMap = () => {
  const navigate = useNavigate();
  const textAreaRef = useRef(null);
  const [inputs, setInputs] = useState({});
  const [currentIndex, setCurrentIndex] = useState(() => {
    const savedIndex = localStorage.getItem("currentIndex");
    return savedIndex ? JSON.parse(savedIndex) : 0;
  });

  const handleInputChange = (e) => {
    setInputs({
      ...inputs,
      [currentIndex]: e.target.value,
    });
  };

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
    localStorage.setItem("currentIndex", JSON.stringify(currentIndex));
  }, [currentIndex]);

  const sendGapMap = async () => {

    const completed_inputs = Object.values(inputs).filter((input) => input.trim().length > 0)
    const gap_progress = (Number(completed_inputs.length) / Number(gapMaps.length)) * 100

    const payload = {
      todays_fact: inputs[0],
      todays_feeling: inputs[1],
      urgency: inputs[2],
      what_got_me_here: inputs[3],
      future_facts: inputs[4],
      future_feelings: inputs[5],
      impact: inputs[6],
      what_do_i_have_to_become: inputs[7],
      progress: gap_progress,
    };

    try {
      const prevMessagePage = localStorage.getItem("prevMessagePage") === "true";
      if (prevMessagePage) {
        navigate("/message-page")
      } else {
        navigate("/plan-for-success");
      }
      const res = await apiServiceHandler('POST', 'api/gap', payload)
    } catch (error) {
      console.log("Failed to save gap map" + error);
    }
  }

  const handleNext = (e) => {
    e.preventDefault();

    if (!inputs[currentIndex]) {
      toastr.error("Please fill the input field")
      return
    }

    if (currentIndex === gapMaps.length - 1) {
      sendGapMap()
    }
    setCurrentIndex((prevIndex) =>
      prevIndex < gapMaps.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const skipStep = (e) => {
    e.preventDefault()
    if (currentIndex === gapMaps.length - 1) {
      sendGapMap()
    }
    setCurrentIndex((prevIndex) =>
      prevIndex < gapMaps.length - 1 ? prevIndex + 1 : prevIndex
    );
  }

  const handleBack = (e) => {
    e.preventDefault();
    if (currentIndex == 0) {
      navigate("/onboarding-driver");
    }
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiServiceHandler('GET', 'api/gap');
        console.log(res)
        if (res.status && res.data) {
          setInputs({
            0: res.data.todays_fact || "",
            1: res.data.todays_feeling || "",
            2: res.data.urgency || "",
            3: res.data.what_got_me_here || "",
            4: res.data.future_facts || "",
            5: res.data.future_feelings || "",
            6: res.data.impact || "",
            7: res.data.what_do_i_have_to_become || ""
          });
        }
      } catch (error) {
        console.log("Failed to fetch data")
      }
    };

    fetchData();
  }, []);


  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="credo-heading">GAP MAP</div>
              <form className="driver-form">
                <div className="driver-view__field">
                  <ReactPlayer
                    url={gapMaps[currentIndex].videoUrl}
                    config={{
                      vimeo: {
                        playerOptions: {
                          title: true,
                          byline: false,
                          portrait: false,
                        },
                      },
                    }}
                    controls={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <h4 style={{ fontWeight: "lighter", color: "#fff" }}>
                  {gapMaps[currentIndex].title}
                </h4>
                <textarea
                  type="text"
                  className="credo-input"
                  ref={textAreaRef}
                  value={inputs[currentIndex] || ""}
                  onChange={handleInputChange}
                />

                <div
                  style={{ display: "flex", gap: "1rem", alignItems: "center" }}
                >
                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={handleBack}
                    style={
                      gapMaps[currentIndex].isBack
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <span className="driver-button__label">BACK</span>
                  </button>

                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={handleNext}
                  >
                    <span className="driver-button__label">SAVE</span>
                  </button>
                  <div
                    style={{
                      marginTop: "2rem",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={skipStep}
                  >
                    skip
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default GapMap;